import React, { useEffect, useRef, useState } from 'react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Swiper, SwiperRef, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import { useLayoutContext } from '../../Contexts/LayoutContext';
import StoreService from '../../Services/StoreService';
import { useOrderTypeContext } from '../../Contexts/OrderTypeContext';
import { useStoreContext } from '../../Contexts/StoreContext';

  const Banners = () => {

    const swiperRef = useRef<SwiperRef>(null);
    const swiperRefPrincipal = useRef<SwiperRef>(null);
    const [loading, setLoading] = useState(false);
    const { isMobile, banners, setBanners, enableLoadProducts, setEnableLoadProducts } = useLayoutContext();
    const { orderType, getOrderTypeIdByName } = useOrderTypeContext();
    const { currentStore } = useStoreContext();

    const [slidesPerView, setSlidesPerView] = useState<number>(() => {
        const storedValue = localStorage.getItem('slides_per_view_banners');
        return storedValue !== null ? Number(storedValue) : isMobile ? 1.08 : 3;
    });

    const handleChangeSlide = (index: number) => {
        if (swiperRef.current && swiperRef.current.swiper && swiperRefPrincipal.current) {
            swiperRef.current.swiper.slideTo(index);
            swiperRefPrincipal.current.swiper.slideTo(index);
        }
    }

    const loadBanners = async () => {

        if (!enableLoadProducts) {
            setEnableLoadProducts(true);
            return;
        }

        setLoading(true);
        try {
            const storeSevice = new StoreService(orderType);
            const payload = {
                store_id: currentStore.id,
                order_type: Number(getOrderTypeIdByName(orderType))
            }
            const data = await storeSevice.banners(payload);
            if (data) {
                setBanners(data);
            } else {
                setBanners([]);
            }
        } catch (error) {
            setBanners([]);
        } finally {
            setLoading(false);
        }
    };

    const checkSlidesPerView = () => {
        if (window.innerWidth < 640) {
            if (banners.length === 1) {
                setSlidesPerView(1)
            } else {
                setSlidesPerView(1.08)
            }
        } else if (window.innerWidth < 1024) {
            setSlidesPerView(2.15)
        } else {
            setSlidesPerView(3.15)
        } 
    }

    useEffect(() => {
        checkSlidesPerView();
        window.addEventListener('resize', () => {
            checkSlidesPerView()
        });

        loadBanners();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        checkSlidesPerView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [banners]);

    useEffect(() => {
        localStorage.setItem('slides_per_view_banners', slidesPerView.toString());
    }, [slidesPerView]);

    useEffect(() => {
        if (isMobile) {
            localStorage.removeItem('slides_per_view_banners');
        }
    }, [isMobile]);

    //* condição apenas para retorno de erro da API (inicializa com dataFakeForLoading e currentStore.has_banner)
    if (banners.length === 0) return null;

    return (
        <div id="boxBanners" className='grid self-start w-full gap-4'>
            <Swiper
                ref={swiperRef}
                spaceBetween={isMobile ? 8 : 18}
                modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                slidesPerView={slidesPerView}
                centeredSlides={false}
                keyboard={{enabled: true}}
                className='flex w-full swiperBullets swiperNavigation'
                onSlideChange={(swiper: any) => {
                    handleChangeSlide(swiper.activeIndex)
                }}
                pagination={isMobile && {
                    clickable: true,
                        renderBullet: function (index: number, className: string) {
                        return '<span class="' + className + '"></span>';
                    },
                }}
                navigation={!isMobile}
                >
                {
                    banners?.map((banner: any, index: number) => (
                        <SwiperSlide
                            key={index} data-hash={`slideBanner1${index}`}
                            className={'flex aspect-[3/2]'}
                            onClick={() => handleChangeSlide(index)}
                            >
                            {!loading 
                                ? 
                                    <a href={banner.url} 
                                        className='
                                            flex overflow-hidden w-full rounded-xl cursor-pointer hover:opacity-90 transition ease-in-out duration-200
                                            h-full bg-cover bg-center
                                        '
                                        style={{backgroundImage: `url('${banner.background_image}')`}}
                                        >
                                    </a>
                                : <div className="flex bg-gray-200 w-full rounded-xl aspect-[3/2]"></div>
                            }
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        </div>
    )
}

export default Banners;
